<div *ngIf="loading" class="my-container">
  <ng-template #customLoadingTemplate>
    <div class="custom-class">{{ loaderText }}</div>
  </ng-template>

  <ngx-loading [show]="loading" [template]="customLoadingTemplate"></ngx-loading>
</div>

<div mdbModal #confirmModal="mdbModal" id='myModal' class="modal fade left" id="fullHeightModalRight" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 1050;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header" cdkDragHandle>
        <span>Wbidmax web app</span>
        <button type="button" class="close" data-dismiss="modal" (click)="confirmModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <label id='focusHelper'></label>
      </div>
      <div class="modal-body">
        <span style="font-size: 18px;">You do not have the newest Version of WbidMax. You are using version
          {{localVersion}} and the newest version is {{version}}</span>
      </div>
      <div class="modal-footer justify-content-center">
        <a mdbBtn color="success" [outline]="true" class="waves-effect" (click)="clearCache(); confirmModal.hide()"
          mdbWavesEffect>Update Now</a>
        <a mdbBtn color="danger" #confirmBtnClose [outline]="true" class="my-0 waves-light" type="button" mdbWavesEffect
          data-dismiss="modal" (click)="updateModalExitBtnHandler()">Exit</a>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>